import store from "@/store";
import { isCustomDomain } from "@/utils/custom-domain";
import { platformSignOutUrl } from "@/utils/custom-domain-auth";

/**
 * 登出並重新載入頁面。頭像選單（Header2）與手機的個人中心（MemberHome）共用。
 *
 * @param {Vue} vm 呼叫的元件（用它的 $notify 顯示「登出成功」）。
 *   要傳元件本身，不能只傳 this.$notify —— $notify 裡面用 this.$root，單獨拿出來呼叫會丟錯，
 *   登入狀態已經清掉了，卻停在重新載入之前（畫面一直轉圈）。
 * @param {string} [goTo] 登出後要去的站內路徑；沒給就在原頁重新載入。
 *   要登入才看得到的頁面（例如個人中心）原地重新載入只會被導去登入頁，所以改回首頁。
 */
export async function signOutAndReload(vm, goTo = null) {
  const success = await store.dispatch("SignOut");
  // 「登入後導回」的網址只對這次登入有意義；留著的話，下一個人登入會被導到上一個人沒去成的頁面
  try {
    localStorage.removeItem("redirectAfterLogin");
  } catch (e) {
    /* 略過 */
  }
  const reload = () => (goTo ? window.location.assign(goTo) : window.location.reload());

  // 提示出錯也不能擋住重新載入
  const notify = (opts) => {
    try {
      vm.$notify(opts);
    } catch (e) {
      console.warn("登出提示顯示失敗", e);
    }
  };

  // 子站網域：這裡的登入狀態是從平台交接來的，平台那邊也要登出，登出完再回到這一頁
  if (isCustomDomain()) {
    window.location.href = platformSignOutUrl();
    return;
  }

  if (success) {
    notify({ content: "登出成功，頁面即將重新載入", status: "success" });
    setTimeout(reload, 500);
  } else {
    notify({ content: "登出失敗，頁面即將重新載入。", status: "error" });
    localStorage.clear();
    setTimeout(reload, 1500);
  }
}
